module.exports = __webpack_public_path__ + "img/index-b-slide3.0e0486ab.jpg";